/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowZigZag = createReactComponent("outline", "arrow-zig-zag", "IconArrowZigZag", [["path", { "d": "M6 20v-10l10 6v-12", "key": "svg-0" }], ["path", { "d": "M13 7l3 -3l3 3", "key": "svg-1" }]]);

export { IconArrowZigZag as default };
//# sourceMappingURL=IconArrowZigZag.mjs.map
